import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import BookingDetails from '../../features/bookings/BookingDetails';
import BookingInvoiceDetails from '../../features/bookings/BookingInvoiceDetails';
import AddBooking from '../../features/bookings/AddBooking';
import Bookings from '../../features/bookings/Bookings';
import SearchBookableAccommodations from '../../features/searchBookableAccommodations/SearchBookableAccommodations';
import NotFound from '../../common/components/router/NotFound';
import NewContainerDetails from '../../features/bookings/NewContainerDetails';
import BookingCrossInvoiceDetails from '../../features/bookings/BookingCrossInvoiceDetails';
import BookingCompensationInvoice from '../../features/bookings/BookingCompensationInvoiceDetails';

const BookingAppRoutes = () => (
  <Routes>
    <Route
      path="/search-bookings"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingRead]}>
          <Bookings />
        </PrivateRoute>
      }
    />
    <Route
      path="/:bookingId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.BookingRead, PERMISSIONS.BookingModify]}
        >
          <BookingDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingModify]}>
          <AddBooking />
        </PrivateRoute>
      }
    />
    <Route
      path="/:bookingId/:customerId"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingModify]}>
          <BookingDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/:bookingId/invoice/:invoiceId"
      element={<Navigate to="false" replace />}
    />
    <Route
      path="/:locale/:bookingId/invoice/:invoiceId/:copy?"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingRead]}>
          <BookingInvoiceDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/:bookingId/invoice/:invoiceId"
      element={<Navigate to="false" replace />}
    />
    <Route
      path="/:locale/:bookingId/crossinvoice/:invoiceId/:copy?"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingRead]}>
          <BookingCrossInvoiceDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/:bookingId/compensationinvoice/:invoiceId/:copy?"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingRead]}>
          <BookingCompensationInvoice />
        </PrivateRoute>
      }
    />
    <Route
      path="/bookingcontainer/newContainer"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingModify]}>
          <NewContainerDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/search-accommodations"
      element={
        <PrivateRoute permissions={[PERMISSIONS.BookingRead]}>
          <SearchBookableAccommodations />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default BookingAppRoutes;
